<template>
  <div>
    <ul v-if="isGourmet" class="categoryChips">
      <li v-for="(chip, i) in menus" :key="i">
        <p class="chip selectable"
          :class="{ 'selected': selected.includes(i) }"
          @click="clickCategory(i, $event)">{{ sectionList[i]['name'] }}</p>
      </li>
    </ul>
    <div v-else style="margin-top: 24px;"></div>

    <div v-for="(menu, j) in menus" :key="j">
    <section id="{{ sectionList[j]['id'] }}" v-if="isShow(j)">
      <h2>{{ menu[0].category_name }}<span class="sub">{{ menu.length }}件</span></h2>
      <ul class="menuList">
        <ShopDetailMenu
          v-for="(item, k) in menu" :key="k"
          :menu="item"
        ></ShopDetailMenu>
      </ul>
    </section>
  </div>
  </div>
</template>
<script>
import ShopDetailMenu from '@/js/componets/ShopDetailMenu.vue';

export default {
  components: {
    ShopDetailMenu
  },
  props: {
    menus: Object,
    isGourmet: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      sectionList: {
        1: { id: 'course', name: 'コース' },
        2: { id: 'cooking', name: '料理' },
        3: { id: 'drink', name: 'ドリンク' },
        4: { id: 'lunch', name: 'ランチ' },
        5: { id: 'other', name: 'その他' }
      },
      selected: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.selected = Object.keys(this.menus)
    },
    clickCategory(index, e) {
      e.target.blur()
      if (!this.selected.includes(index)) {
        this.selected.push(index)
      } else {
        this.selected = this.selected.filter(v => {
          return v !== index
        })
      }
    },
    isShow(index) {
      return (this.selected.length > 0) ? this.selected.includes(index) : true
    }
  }
}
</script>
